import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

import PlanTaskEntityActivityCardHeader from './PlanTaskEntityActivityCardHeader/PlanTaskEntityActivityCardHeader';
import PlanTaskEntityActivityCardTitle from './PlanTaskEntityActivityCardTitle/PlanTaskEntityActivityCardTitle';
import { ACTIVITY_VARIANTS } from '../../../../../constants';
import { Task } from '../../../types';
import PlanTaskContextPath from '../../PlanTaskContextPath/PlanTaskContextPath';

const PlanTaskEntityActivityCardDetails = ({
  task,
  variant,
}: {
  variant?: typeof ACTIVITY_VARIANTS.ADDED | typeof ACTIVITY_VARIANTS.REMOVED;
  task: Task;
}) => (
  <Flex flexDirection="column" overflow="hidden" color="charcoal900">
    <PlanTaskEntityActivityCardHeader variant={variant} />
    <PlanTaskEntityActivityCardTitle task={task} variant={variant} />
    <PlanTaskContextPath
      task={task}
      color="charcoal800"
      style={{ ...theme.typography.bodySmall, marginTop: 8 }}
    />
  </Flex>
);

export default PlanTaskEntityActivityCardDetails;
